import { h, Component } from 'preact';
import { connect } from 'preact-redux';

import { find } from 'lodash';

import Sidebar from '../components/Sidebar';
import LoadingSpinner from './LoadingSpinner';

class ContactPage extends Component {
    constructor({ path }) {
        super();
    }

    render({ path, pages, loading }) {
        const currentPage = find(pages, { sitePath: `/kapcsolat` });

        return (
            <div class="page contact-page">
                <main class="page-main">
                    <div class="page-container">
                        <LoadingSpinner visible={loading} />
                        <h1>{currentPage.attributes.h1 || currentPage.attributes.title}</h1>
                        <div class="markdown-content" dangerouslySetInnerHTML={{ __html: currentPage.html }}></div>
                    </div>
                </main>
                <Sidebar />
            </div>
        );
    }
}

const mapStateToProps = (state, { path }) => ({
    pages: state.pages,
    html: find(state.pages, { sitePath: `/kapcsolat` }).html,
    loading: state.loading
});

export default connect(mapStateToProps)(ContactPage);


// WEBPACK FOOTER //
// ./src/components/ContactPage.js